import Keycloak from '../vendor/keycloak-js/lib/keycloak'

let installed = false

export default class VueKeyCloak {
  static install
  static version
}

VueKeyCloak.install = (Vue, options) => {
  options = Object.assign({
    keycloakOptions: {},
    keycloakInitOptions: {},
    refreshTime: 10
  }, options)
  if (installed) return
  installed = true

  const keycloak = new Keycloak(options.keycloakOptions)

  const watch = new Vue({
    data () {
      return {
        ready: false,
        authenticated: false,
        user: null,
        token: null,
        resourceAccess: null
      }
    }
  })

  keycloak.init(options.keycloakInitOptions).then((isAuthenticated) => {
    updateWatchVariables(isAuthenticated).then(() => {
      watch.ready = true
    })

    if (isAuthenticated) {
      setTimeout(() => {
        keycloak.updateToken(options.refreshTime + 2)
          .then((refreshed) => {
            if (refreshed) updateWatchVariables(true)
          })
      }, options.refreshTime * 1000)
    }
  })

  function updateWatchVariables (isAuthenticated = false) {
    watch.authenticated = isAuthenticated

    if (isAuthenticated) {
      watch.token = keycloak.token
      watch.resourceAccess = keycloak.resourceAccess
      return new Promise((resolve, reject) => {
        keycloak.loadUserProfile().then((user) => {
          watch.user = user
          resolve()
        })
      })
    } else {
      return Promise.resolve()
    }
  }

  Object.defineProperty(Vue.prototype, '$keycloak', {
    get () {
      keycloak.ready = watch.ready
      keycloak.user = watch.user
      return keycloak
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/vue-keycloak.js